import { IFilter } from '../../types/filters';
import { OfferIdContainer } from '../../containers/advancedFilters/OfferIdContainer';

export const offerId: IFilter = {
  component: OfferIdContainer,
};
